/**
 * @Author: Ramkumar <raramakrishna>
 * @Date:   Mar-06-2017
 * @Email:  raramakrishna@egencia.com
 * @Filename: ui-service.js
 */

(function($, document, Handlebars, _, EG) {
  "use strict";

  var TEMPLATES = {
      source: Handlebars.templates,
      dir: {
        common: "common/",
        partials: "partials/"
      },
      separator: "/"
    },
    CONFIG = {
      flag: "enabled",
      context: "context",
      supportedAttrs: [
        {
          label: "mandatory",
          attrName: "required"
        },
        {
          label: "readonly",
          attrName: "disabled"
        },
        {
          label: "mureadonly",
          attrName: "mureadonly"
        },
        {
          label: "maxlength",
          attrName: "maxlength"
        }
      ],
      valueLessAttrs: ["readonly", "disabled", "required", "autofocus", "mureadonly"]
    };

  // LOCAL METHODS
  function _sortByGroupAndOrder(obj1, obj2) {
    var order1 = parseInt(obj1.order, 10),
      order2 = parseInt(obj2.order, 10),
      group1 = parseInt(obj1.group, 10),
      group2 = parseInt(obj2.group, 10);

    if (!obj1 && !obj2) {
      return 0;
    }

    if (group1 > group2) {
      return 1;
    }

    if (group1 < group2) {
      return -1;
    }

    if (order1 > order2) {
      return 1;
    }

    if (order1 < order2) {
      return -1;
    }

    return 0;
  }

  function getNestedValue(obj, key) {
    return key.split(".").reduce(function(result, key) {
      return result ? result[key] : "";
    }, obj);
  }

  function UIService() {}

  UIService.prototype = {
    constructor: UIService,

    _renderHTMLFromConfig: function(htmlConfig, data) {
      var renderHTML,
        htmlArray = [];

      renderHTML = function(config, parentTemplateName) {
        var html,
          templateData = {},
          templateContent = [],
          parentTemplateConfig,
          parentTemplate;

        parentTemplateConfig = config[0];
        config.splice(0, 1);

        parentTemplate =
          TEMPLATES.source[
            TEMPLATES.dir.partials + parentTemplateConfig.parentTemplatePath
          ];

        if (!parentTemplate) {
          for (
            var i = 0;
            i < parentTemplateConfig.possibleParentTemplatePaths.length;
            i++
          ) {
            parentTemplate =
              TEMPLATES.source[
                TEMPLATES.dir.partials +
                  parentTemplateConfig.possibleParentTemplatePaths[i]
              ];
            if (parentTemplate) {
              break;
            }
          }
        }

        for (var key in config) {
          var templateName, cfg;

          cfg = config[key];

          if (_.isObject(cfg)) {
            if (_.isArray(cfg)) {
              config[key] = renderHTML(cfg, cfg.parent);
              templateData[key] = {};
              templateData[key].content = new Handlebars.SafeString(
                config[key].content
              ).string;
              templateContent.push(templateData[key].content);
            } else {
              templateName = Object.keys(cfg)[0];

              templateData[templateName] = {};
              templateData[templateName].content = new Handlebars.SafeString(
                cfg[templateName].content
              );

              templateContent.push(cfg[templateName].content);
            }
          }
        }

        templateData.content = new Handlebars.SafeString(
          templateContent.join("")
        );
        templateData = _.extend({}, templateData, data);

        if (_.isFunction(parentTemplate)) {
          html = parentTemplate(templateData);
        } else {
          html = templateData.content.string;
        }

        return {
          content: html
        };
      };

      _.each(htmlConfig, function(config, parent) {
        htmlArray.push(renderHTML(config, parent).content);
      });

      return htmlArray.join("");
    },

    /**
     * @public
     * @param {String} path `partial name for the template to be used`
     *            'path/to/partial'
     * @param {Array} possiblePaths `list of all possible partial name when exact match not found`
     *            [ 'path/to', 'path' ]
     * @returns {Function} `Handlebars pre-compiled template function`
     */
    _parseTemplateConfigToHTML: function(
      parentTemplateConfig,
      parent,
      shouldCheckPossiblePaths,
      data
    ) {
      var parseHTMLToConfig,
        parentCompiledObject = {},
        compiledHTMLConfig = {},
        templateData = {},
        self = this;

      parseHTMLToConfig = function(templateConfig, parentObject) {
        var template,
          templateParents,
          html = "";

        template =
          TEMPLATES.source[
            TEMPLATES.dir.partials + templateConfig.templatePath
          ];

        if (!template && shouldCheckPossiblePaths) {
          for (
            var i = 0;
            i < templateConfig.templatePossiblePaths.length;
            i++
          ) {
            template =
              TEMPLATES.source[
                TEMPLATES.dir.partials + templateConfig.templatePossiblePaths[i]
              ];
            if (template) {
              break;
            }
          }
        }

        if (_.isFunction(template)) {
          templateData = _.extend({}, data, templateConfig);
          html = template(templateData);
        }

        templateParents = templateConfig.templateParents;
        templateParents.push(templateConfig.templateName);

        //this(;) is required, as next line is a IIFE
        (function(obj, keyPath, value) {
          var lastKeyIndex = keyPath.length - 1,
            key,
            template = {},
            parentPath,
            parents;

          for (var i = 0; i < lastKeyIndex; ++i) {
            key = keyPath[i];

            parents = keyPath.slice(0, _.indexOf(keyPath, key) + 1);
            parents.push(key);
            parentPath = parents.join("/");

            if (!(key in obj)) {
              obj[key] = [
                {
                  content: [],
                  parentTemplatePath: self._getTemplateCompletePath(parentPath),
                  possibleParentTemplatePaths: self._getTemplatePathPossiblePaths(
                    parentPath
                  )
                }
              ];
            }

            obj = obj[key];
          }

          template[keyPath[lastKeyIndex]] = {};
          template[keyPath[lastKeyIndex]].content = value;
          if (obj[0]) {
            obj[0].content.push(value);
          }
          obj.push(template);
        })(parentObject, templateConfig.templateParents, html);

        return parentObject;
      };

      _.each(parentTemplateConfig, function(config) {
        var temp;

        temp = parseHTMLToConfig(config, parentCompiledObject);

        compiledHTMLConfig = _.extend({}, compiledHTMLConfig, temp);
      });

      _.each(parentTemplateConfig, function(config) {
        var currentTemplate, template;

        currentTemplate = compiledHTMLConfig[config.templateParents[0]];

        if (currentTemplate && config.templateName in currentTemplate) {
          _.each(currentTemplate, function(tmpl, idx) {
            if (_.contains(_.keys(tmpl), config.templateName)) {
              currentTemplate[idx] = currentTemplate[config.templateName];
              currentTemplate[idx]["parent"] = config.templateName;
              delete currentTemplate[config.templateName];
            }
          });
        }
      });

      //TODO: There is an issue in sorting and Ram to look into this once till then commenting.
      // _.each(compiledHTMLConfig, function ( compiledElem ) {
      // 	compiledElem.sort(_sortByGroupAndOrder);
      // });

      return this._renderHTMLFromConfig(compiledHTMLConfig, data);
    },

    _parseTemplateConfigsToHTML: function(
      templateConfigs,
      checkPossiblePaths,
      data
    ) {
      var html = [],
        self = this;

      templateConfigs.sort(_sortByGroupAndOrder);

      _.each(templateConfigs, function(templateConfig, parentTemplate) {
        if (_.isArray(templateConfig)) {
          html.push(
            self._parseTemplateConfigToHTML(
              templateConfig,
              parentTemplate,
              checkPossiblePaths,
              data
            )
          );
        }
      });

      return html;
    },

    _getElemAttrs: function(elemConfig) {
      var attrs = [],
        self;

      self = this;

      CONFIG.supportedAttrs.forEach(function(supportedAttr) {
        if (!elemConfig.hasOwnProperty(supportedAttr.label)) {
          return;
        }

        if (
          self._isValueLessAttribute(supportedAttr.attrName) &&
          elemConfig[supportedAttr.label] == false
        ) {
          return;
        }

        attrs.push(
          supportedAttr.attrName + "=" + elemConfig[supportedAttr.label]
        );
      });

      return attrs.join(" ");
    },

    _isValueLessAttribute: function(attr) {
      var isValueLessAtrr;

      isValueLessAtrr = _.indexOf(CONFIG.valueLessAttrs, attr);

      if (isValueLessAtrr !== -1) {
        return true;
      }

      return false;
    },

    /**
     * @public
     * @param {Object | Array | String} config
     *            {
     * 				parent: {
     * 					child: {
     * 						grandchild: ''
     * 						enabled: false
     * 					}
     * 				}
     * 			}
     *            or
     *                'path/to'
     *            or
     *                ['path', 'to', 'partial' ]
     * @param {String} flag    `flag to validate the config`
     *            'enabled'
     * @returns {Array}
     *            [ 'parent/child' ]
     *            or
     *                [ 'path/to' ]
     *            or
     *                [ 'path/to/partial' ]
     */
    _getTemplatesConfig: function(
      configs,
      formContext,
      shouldEnableFlag,
      parentFolder
    ) {
      var group = 1,
        order = 0,
        self = this;

      configs = _.clone(configs);

      var templatesConfig = [],
        templateConfig = {};

      _.each(configs, function(config, key) {
        templateConfig = self._buildTemplateConfig({
          serverConfig: config,
          formContext: formContext,
          parentPath: key,
          parentFolder: parentFolder,
          shouldEnableFlag: shouldEnableFlag,
          group: group
        });

        order++;

        templateConfig.order = order;
        templateConfig.group = group;

        templatesConfig.push(templateConfig);
      });

      return templatesConfig;
    },

    _buildTemplateConfig: function(baseConfig) {
      var composeTemplateConfig,
        group,
        self = this,
        elemUIConfig = [],
        serverConfig = _.clone(baseConfig.serverConfig),
        parentTemplate,
        formContext,
        shouldEnableFlag,
        parentFolder;

      parentTemplate = baseConfig.parentPath;
      formContext = baseConfig.formContext;
      shouldEnableFlag = baseConfig.shouldEnableFlag;
      parentFolder = baseConfig.parentFolder;

      composeTemplateConfig = function(config, parentPath) {
        var templateAttrs,
          templateServerConfig = _.clone(config),
          templateUIConfig;

        _.each(templateServerConfig, function(templateConfig, elemName) {
          var fieldName,
            templateName,
            allTemplates = [],
            templatePath,
            templatePossiblePaths,
            templateParents = [],
            parentTemplatePath = parentPath + "",
            parentKeyPath,
            templateParent;

          if (_.isObject(templateConfig)) {
            if (!templateConfig[shouldEnableFlag]) {
              return;
            }
            templatePath = parentTemplatePath
              ? parentTemplatePath + TEMPLATES.separator + elemName
              : elemName;
            templateServerConfig[elemName] = composeTemplateConfig(
              templateConfig,
              templatePath
            );
          } else {
            if (elemName == shouldEnableFlag && templateConfig) {
              templatePath = parentTemplatePath + "";

              allTemplates = templatePath.split("/");
              templateName = _.last(allTemplates);

              templateParents = parentTemplatePath.split("/");

              if (templateParents.length > 1) {
                templateParents.splice(-1, 2);
              }

              parentTemplatePath = templateParents.join("/");
              parentTemplatePath +=
                TEMPLATES.separator +
                templateParents[templateParents.length - 1];

              fieldName = allTemplates.join("][");
              fieldName = "[" + fieldName + "]";

              templateParent = _.clone(templateParents);
              // Slice out the top most parent of the nested structure
              // It's 1 because 0 is the top-most parent !
              templateParent.splice(1, 1);

              parentKeyPath = templateParent.join(".");

              group = getNestedValue(serverConfig, parentKeyPath);
              group = group || {
                order: 0
              };

              templateAttrs = self._getElemAttrs(config);
              templatePossiblePaths = self._getTemplatePathPossiblePaths(
                templatePath,
                parentFolder
              );

              templateServerConfig = {
                parentTemplatePath: self._getTemplateCompletePath(
                  parentTemplatePath
                ),
                templateName: templateName,
                templatePath: self._getTemplateCompletePath(templatePath),
                templateParents: templateParents,
                templatePossiblePaths: templatePossiblePaths,
                order: templateServerConfig.order || 0,
                group: group.order,
                formContext: formContext + fieldName,
                required: templateServerConfig.mandatory,
                mureadonly:  templateServerConfig.mureadonly,
                disabled: templateServerConfig.readonly,
                attrs: templateAttrs
              };

              elemUIConfig.push(templateServerConfig);
            }
          }
        });

        templateUIConfig = _.clone(templateServerConfig);

        return templateUIConfig;
      };

      composeTemplateConfig(serverConfig, parentTemplate);

      elemUIConfig.sort(_sortByGroupAndOrder);

      return elemUIConfig;
    },

    /**
     * @public
     * @param {Object} options `options that configures the template`
     *    {Object | Array | String } config
     *            {
     * 				parent: {
     *					child: ''
     *				}
     *			}
     *    {String} configFlag `flag to enabling vs disabling the config`
     *    {Object} context `data that to be binded to the template`
     *            {
     * 				first_name: 'Goku',
     * 				middle_name: 'San',
     * 				last_name: 'Saiyajin'
     * 			}
     *    {Boolean} checkPossibilities `whether to look for Local vs Global templates`
     *
     * @returns {HTMLElement}
     *            <div class='container'>
     *                <span class='first_name'>Goku</span>
     *                <span class='middle_name'>San</span>
     *                <span class='last_name'>Saiyajin</span>
     *            </div>
     */
    getHTMLFromConfig: function(options) {
      var defaultOptions = {
          config: {},
          parentFolder: undefined,
          shouldEnableFlag: CONFIG.flag,
          formContext: CONFIG.context,
          data: {},
          checkPossiblePaths: false
        },
        templatesConfig,
        self = this,
        html,
        config;

      options = _.extend({}, defaultOptions, options);

      config = this._getTemplateConfig(options.config, options.template);

      templatesConfig = this._getTemplatesConfig(
        config,
        options.formContext,
        options.shouldEnableFlag,
        options.parentFolder
      );

      templatesConfig.sort(_sortByGroupAndOrder);

      html = self._parseTemplateConfigsToHTML(
        templatesConfig,
        options.checkPossiblePaths,
        options.data
      );

      return html.join("");
    },

    // UTILS

    /**
     * @private
     * @param {String} path `the exact match path to the partial`
     *            'path/to/inner/most/partial'
     * @returns {Array}
     *                [
     *                    'path/to/inner/partial',
     *                    'path/to/partial',
     *                    'path/partial',
     *                    'partial'
     *                ]
     */
    _getTemplatePathPossiblePaths: function(path, parentFolder) {
      var possiblePaths = [],
        recursePath,
        pathToRemovePos = 2, //from last
        pathCountToRemove = 1,
        minPathLength = 1;

      if (parentFolder) {
        path = parentFolder + TEMPLATES.separator + path;
      }

      recursePath = function(path) {
        var paths = path.split(TEMPLATES.separator),
          possiblePath;

        if (paths.length == minPathLength) {
          return possiblePaths.push(TEMPLATES.dir.common + path);
        }

        possiblePath = paths.join(TEMPLATES.separator);

        possiblePaths.push(possiblePath);
        possiblePaths.push(TEMPLATES.dir.common + possiblePath);

        paths.splice(paths.length - pathToRemovePos, pathCountToRemove);

        recursePath(paths.join(TEMPLATES.separator));
      };

      recursePath(path);

      return possiblePaths;
    },

    _getTemplateCompletePath: function(path) {
      if(EG.Users.RequestedUser?.isCrossGpid){
        return EG.Users.RequestedUser.productId + TEMPLATES.separator + path;
      }
      if (!EG.user || !EG.user.productId) {
        return path;
      }
      return EG.user.productId + TEMPLATES.separator + path;
    },

    _getTemplateConfig: function(configs, template) {
      var templates = {},
        templateConfig;
      for (var key in configs) {
        var tempObj = {};
        tempObj[key] = configs[key];
        templates[key] = tempObj;
      }

      return template ? templates[template] : configs;
    }
  };

  EG.UIService = new UIService();
})(jQuery, document, Handlebars, _, EG);
